// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"60fc640b","264":"c2ab5bb6","480":"ecb94c44","638":"b5083554","854":"bba16d23"}[chunkId] + ".chunk.js";
};